import kuPiperCoreBaseInstance, {IKuPiperCore as IKuPiperCoreBase} from '@baidu/ku-piper-core';

import {HookMap, HookNameMap} from './map/hook';
import {ProxyMap, ProxyNameMap} from './map/proxy';
import {SlotPositionMap, SlotScopeMap, SlotTypeMap, SlotActionMap, TextDefaultMap} from './map/slot';

import SlotErrorBoundary from './SlotErrorBoundary';

export interface IKuPiperMapOptions {
    /**
     * 从知识库代码引入
     */
    hookNameMap: typeof HookNameMap;
    proxyNameMap: typeof ProxyNameMap;
    slotPositionMap: typeof SlotPositionMap;
    slotScopeMap: typeof SlotScopeMap;
    slotType: typeof SlotTypeMap;
    slotAction: typeof SlotActionMap;

    hookMap: typeof HookMap; // 中间件对外提供的hook集合
    proxyMap: typeof ProxyMap;
    textDefaultMap: typeof TextDefaultMap;
}

const coreInstance = kuPiperCoreBaseInstance as IKuPiperCoreBase<IKuPiperMapOptions>;

// 增加map信息
coreInstance.hookNameMap = HookNameMap;
coreInstance.proxyNameMap = ProxyNameMap;
coreInstance.slotPositionMap = SlotPositionMap;
coreInstance.slotScopeMap = SlotScopeMap;
coreInstance.slotType = SlotTypeMap;
coreInstance.slotAction = SlotActionMap;

coreInstance.hookMap = HookMap;
coreInstance.proxyMap = ProxyMap;
coreInstance.textDefaultMap = TextDefaultMap;

coreInstance.SlotErrorBoundary = SlotErrorBoundary;

export default coreInstance;
